import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import {EstudioRoutingModule} from './estudio-routing.module';
import {EstudioComponent} from './estudio.component';
import {EstudioService} from './estudio.service';
import {EstudioResumenComponent} from './resumen/estudio-resumen.component';
import {EstudioResumenResolver} from './resumen/estudio-resumen-resolver.service';
import {DashboardModule} from '../../_components/dashboard/dashboard.module';
import {NavBarModule} from '../../_components/nav-bar/nav-bar.module';
import {EstudioMapaCurricularComponent} from './mapa-curricular/mapa-curricular.component';
import {CursosResolver} from './_resolvers/cursos-resolver.service';
import {MapaCurricularBusquedaComponent} from './mapa-curricular/mapa-curricular-busqueda.component';
import {GLMMaterialDesignModule} from '../../_components/material-design/material-design.module';
import {AreasResolver} from './_resolvers/areas-resolver.service';
import {MetasFiltrarCategoriaPipe} from './_pipes/metas-filtrar-categoria.pipe';
import {CategoriasMetasResolver} from './_resolvers/categorias-resolver.service';
import {MapaCurricularMetaComponent} from './mapa-curricular/mapa-curricular-meta/mapa-curricular-meta.component';
import {GLMLanguageSelectorComponent} from '../../_directives/glm-language-selector/glm-language-selector.component';
import {MapaCurricularFiltrosComponent} from './mapa-curricular/mapa-curricular-filtros/mapa-curricular-filtros.component';
import {MapaCurricularFiltrosService} from './mapa-curricular/_services/mapa-curricular-filtros.service';
import {AmbitosResolver} from './_resolvers/ambitos-resolver.service';
import {TagsResolver} from './_resolvers/tags-resolver.service';
import {MapaCurricularUnidadComponent} from './mapa-curricular/mapa-curricular-unidad/mapa-curricular-unidad.component';
import {EstudioConexionesService} from './mapa-curricular/_services/estudio-conexiones.service';
import {MapaCurricularService} from './mapa-curricular/_services/mapa-curricular.service';
import {MetaFormComponent} from './meta-form/meta-form.component';
import {GlmModalModule} from '../../_components/glm-modal/glm-modal.module';
import {ProfesoresResolver} from './_resolvers/personas-resolver.service';
import {UnidadFormComponent} from './unidad-form/unidad-form.component';
import {MateriasPeriodoResolver} from './_resolvers/materias-periodo-resolver.service';
import {AlumnosIEPResolver} from './_resolvers/alumnos-iep-resolver.service';
import {UnidadEtapasComponent} from './unidad-etapas/unidad-etapas.component';
import {UnidadResolver} from './_resolvers/unidad-resolver.service';
import {EstudioResumenBarraComponent} from './resumen/estudio-resumen-barra.component';
import {DynamicBarModule} from '../../_components/dynamic-bar/dynamic-bar.module';
import {MapaCurricularBarraComponent} from './mapa-curricular/mapa-curricular-barra.component';
import {UnidadEtapasBarraComponent} from './unidad-etapas/unidad-etapas-barra.component';
import {UnidadEtapasMetasComponent} from './unidad-etapas/unidad-etapas-metas/unidad-etapas-metas.component';
import {UnidadEtapasResolver} from './_resolvers/unidad-etapas-resolver.service';
import {CategoriasUnidadResolver} from './_resolvers/categorias-unidad-resolver.service';
import {UnidadMetaComponent} from './unidad-etapas/unidad-meta/unidad-meta.component';
import {UnidadEtapasService} from './unidad-etapas/_services/unidad-etapas.service';
import {UnidadEtapasEvidenciasComponent} from './unidad-etapas/unidad-etapas-evidencias/unidad-etapas-evidencias.component';
import {UnidadEventoComponent} from './unidad-etapas/unidad-evento/unidad-evento.component';
import {EventoFormComponent} from './evento-form/evento-form.component';
import {MetaListComponent} from './meta-list/meta-list.component';
// import {AngularDraggableModule} from 'angular2-draggable';
// import {SortablejsModule} from 'ngx-sortablejs';
import {UnidadRapidaFormComponent} from './unidad-form/unidad-rapida-form.component';
import {MetaRapidaFormComponent} from './meta-form/meta-rapida-form.component';
import {EventoRapidoFormComponent} from './evento-form/evento-rapido-form.component';
import {UnidadEventosCalendario} from './unidad-etapas/unidad-eventos-calendario/unidad-eventos-calendario.component';
// import {DragulaModule, DragulaService} from 'ng2-dragula';
import {MetaCriteriosListComponent} from './meta-criterios-list/meta-criterios-list.component';
import {UnidadEventosAprendizajeComponent} from './unidad-etapas/unidad-eventos-aprendizaje/unidad-eventos-aprendizaje.component';
import {RubricaComponent} from './unidad-etapas/rubrica/rubrica.component';
import {RubricaUnidadComponent} from './unidad-etapas/rubrica-unidad/rubrica-unidad.component';
import {GlmComentariosModule} from '../../_components/glm-comentarios/glm-comentarios.module';
import {EventoListComponent} from './evento-list/evento-list.component';
import {GoogleApiModule} from 'ng-gapi';
import {GapiPickerService} from '../../_services/gapi-picker';
import {CriteriosSeleccionadosPipe} from './_pipes/criterios-seleccionados.pipe';
import {MateriasPeriodoMeResolver} from './_resolvers/materias-periodo-me-resolver.service';
import {UnidadFormDialogComponent} from './unidad-form/unidad-form-dialog.component';
import {PeriodosResolver} from './_resolvers/periodos-resolver.service';
import {UnidadEventoDetalleComponent} from './unidad-etapas/unidad-eventos-calendario/unidad-evento-detalle.component';
import {UnidadFamiliaComponent} from './unidad-familia/unidad-familia.component';
import {UnidadFamiliaBarraComponent} from './unidad-familia/unidad-familia-barra.component';
import {MateriasFamiliaComponent} from './materias-familia/materias-familia.component';
import {MateriaUnidadesComponent} from './materias-familia/materia-unidades/materia-unidades.component';
import {FamiliaHijoComponent} from './familia-hijo/familia-hijo.component';
import {FamiliaHijoBarraComponent} from './familia-hijo/familia-hijo-barra.component';
import {UserModule} from '../../user/user.module';
import {HtmlEntitiesCleanerPipe} from './_pipes/html-entities-cleaner.pipe';
import {RetroalimentacionListaAlumnosComponent} from './retroalimentacion/retroalimentacion-lista-alumnos/retroalimentacion-lista-alumnos.component';
import {RetroalimentacionEvaluacionComponent} from './retroalimentacion/retroalimentacion-evaluacion/retroalimentacion-evaluacion.component';
import {RetroalimentacionService} from './retroalimentacion/_services/retroalimentacion.service';
import {RetroalimentacionAlumnoComponent} from './retroalimentacion/retroalimentacion-alumno/retroalimentacion-alumno.component';
import {RetroalimentacionMiEvaluacionComponent} from './retroalimentacion/retroalimentacion-mi-evaluacion/retroalimentacion-mi-evaluacion.component';
// import {CKEditorModule} from '@ckeditor/ckeditor5-angular';
import {CustomPipesModule} from '../../_pipes/custom-pipes.module';
import {DashboardRetroalimentacionComponent} from './retroalimentacion/dashboard/dashboard.component';
import {DashboardRetroalimentacionBarraComponent} from './retroalimentacion/dashboard/dashboard-retroalimentacion-barra.component';
import {RetroalimentacionMisMateriasComponent} from './retroalimentacion/retroalimentacion-mis-materias/retroalimentacion-mis-materias.component';
import {GLMAppPipesModule} from '../_pipes/app-glm-pipes.module';
import {RetroalimentacionMateriasBarraComponent} from './retroalimentacion/retroalimentacion-mis-materias/retroalimentacion-materias-barra.component';
import {GlmD3Module} from '../../_components/glm-D3/glm-D3.module';
import {McpResolver} from './_resolvers/mcp-resolver.service';
import {MapaGeneradoComponent} from './mapa-curricular/mapa-generado/mapa-generado.component';
import {PdfPrintableComponent} from './retroalimentacion/pdf-printable/pdf-printable.component';
import {MetaFormDialogComponent} from './meta-form-dialog/meta-form-dialog.component';
import { MetaListExpandedComponent } from './meta-list-expanded/meta-list-expanded.component';
import { MetaFormInjectorComponent } from './meta-form-injector/meta-form-injector.component';
import { MateriaPrerrequisitosComponent } from './materia-prerrequisitos/materia-prerrequisitos.component';
import { MateriaMetasCodigosComponent } from './materia-metas-codigos/materia-metas-codigos.component';
import { MapaMetasBuscadorComponent } from './mapa-metas-buscador/mapa-metas-buscador.component';
import { MapaMetasResultadoComponent } from './mapa-metas-resultado/mapa-metas-resultado.component';
import { MapaMetasComponent } from './mapa-metas/mapa-metas.component';
import { MapaMetaBuscarFormComponent } from './mapa-meta-buscar-form/mapa-meta-buscar-form.component';
import { CompartirRubricaClassroomComponent } from './unidad-etapas/compartir-rubrica-classroom/compartir-rubrica-classroom.component';
import { BotonCriterioComponent } from './retroalimentacion/boton-criterio/boton-criterio.component';
import { BotonCriterioGroupComponent } from './retroalimentacion/boton-criterio-group/boton-criterio-group.component';
import { RetroalimentacionGridComponent } from './retroalimentacion/retroalimentacion-grid/retroalimentacion-grid.component';
import { RetroalimentacionCriterioControlComponent } from './retroalimentacion/retroalimentacion-criterio-control/retroalimentacion-criterio-control.component';
import { RetroalimentacionDialogoComentarioComponent } from './retroalimentacion/retroalimentacion-dialogo-comentario/retroalimentacion-dialogo-comentario.component';
import { RetroalimentacionTrabajoAlumnoComponent } from './retroalimentacion/retroalimentacion-trabajo-alumno/retroalimentacion-trabajo-alumno.component';
import { RetroalimentacionGridTablaComponent } from './retroalimentacion/retroalimentacion-grid-tabla/retroalimentacion-grid-tabla.component';
import { RetroalimentacionTrabajoCriteriosComponent } from './retroalimentacion/retroalimentacion-trabajo-criterios/retroalimentacion-trabajo-criterios.component';
import { AlumnoCheckboxModule } from 'src/app/_components/alumno-checkbox/alumno-checkbox.module';
import { RetroalimentacionBarraComponent } from './retroalimentacion/retroalimentacion-barra/retroalimentacion-barra.component';
import { UnidadFormClassroomComponent } from './unidad-form-classroom/unidad-form-classroom.component';
import { UnidadFormEnlazarClassroomComponent } from './unidad-form-enlazar-classroom/unidad-form-enlazar-classroom.component';
import { RetroalimentacionNotificarModalComponent } from './retroalimentacion-notificar-modal/retroalimentacion-notificar-modal.component';
import { EventoFormClassroomComponent } from './evento-form-classroom/evento-form-classroom.component';
import { UnidadFormClassroomSelectComponent } from './unidad-form-classroom-select/unidad-form-classroom-select.component';
import { RetroalimentacionGridClassroomEstadoComponent } from './retroalimentacion-grid-classroom-estado/retroalimentacion-grid-classroom-estado.component';
import { RetroalimentacionDevolverDialogoComponent } from './retroalimentacion-devolver-dialogo/retroalimentacion-devolver-dialogo.component';
import { UnidadEventoClassroomMcpComponent } from './unidad-evento-classroom-mcp/unidad-evento-classroom-mcp.component';
import { PersonaCardModule } from '../persona-card/persona-card.module';
import { RetroalimentacionNivelTrabajoCriteriosComponent } from './retroalimentacion/retroalimentacion-nivel-trabajo-criterios/retroalimentacion-nivel-trabajo-criterios.component';
import { AutoevaluacionComponent } from './autoevaluacion/autoevaluacion.component';
import { AutoevaluacionNotificacionAlumnoComponent } from './autoevaluacion/autoevaluacion-notificacion-alumno/autoevaluacion-notificacion-alumno.component';
import { AutoevaluacionCriterioComponent } from './autoevaluacion/autoevaluacion-criterio/autoevaluacion-criterio.component';
import { AutoevaluacionCriterioGroupComponent } from './autoevaluacion/autoevaluacion-criterio-group/autoevaluacion-criterio-group.component';
import { AutoevaluacionCriterioButtonComponent } from './autoevaluacion/autoevaluacion-criterio-button/autoevaluacion-criterio-button.component';
import { CkeditorImageDeleteModule } from 'src/app/_directives/ckeditor-image-delete/ckeditor-image-delete.module';
import { RetroalimentacionReportComponent } from './retroalimentacion-report/retroalimentacion-report.component';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { ClasePerdidaModule } from 'src/app/clase-perdida/clase-perdida.module';
import { UnidadModule } from 'src/app/unidad/unidad.module';


@NgModule({
  declarations: [
    EstudioComponent,
    EstudioResumenComponent,
    EstudioResumenBarraComponent,
    EstudioMapaCurricularComponent,
    MapaCurricularBusquedaComponent,
    MapaCurricularMetaComponent,
    MapaCurricularUnidadComponent,
    MapaCurricularFiltrosComponent,
    MapaCurricularBarraComponent,
    MapaGeneradoComponent,
    GLMLanguageSelectorComponent,
    MetaFormComponent,
    MetaFormDialogComponent,
    MetaRapidaFormComponent,
    MetaListComponent,
    MetaCriteriosListComponent,
    UnidadFormComponent,
    UnidadFormDialogComponent,
    UnidadRapidaFormComponent,
    EventoFormComponent,
    EventoListComponent,
    EventoRapidoFormComponent,
    // Unidad etapas
    UnidadEtapasComponent,
    UnidadEtapasBarraComponent,
    UnidadEtapasMetasComponent,
    UnidadEtapasEvidenciasComponent,
    UnidadEventosAprendizajeComponent,
    // ClasePerdidaComponent,
    // ClasePerdidaModal,
    UnidadEventosCalendario,
    UnidadMetaComponent,
    UnidadEventoComponent,
    RubricaComponent,
    RubricaUnidadComponent,
    UnidadEventoDetalleComponent,
    // Retroalimantacion
    RetroalimentacionListaAlumnosComponent,
    RetroalimentacionEvaluacionComponent,
    RetroalimentacionAlumnoComponent,
    RetroalimentacionMiEvaluacionComponent,
    DashboardRetroalimentacionComponent,
    DashboardRetroalimentacionBarraComponent,
    RetroalimentacionMisMateriasComponent,
    RetroalimentacionMateriasBarraComponent,
    PdfPrintableComponent,
    // Unidad familia
    UnidadFamiliaComponent,
    UnidadFamiliaBarraComponent,
    MateriasFamiliaComponent,
    MateriaUnidadesComponent,
    FamiliaHijoComponent,
    FamiliaHijoBarraComponent,
    // NivelacionesWidgetComponent,
    // Declaración de pipes
    MetasFiltrarCategoriaPipe,
    CriteriosSeleccionadosPipe,
    HtmlEntitiesCleanerPipe,
    MetaListExpandedComponent,
    MetaFormInjectorComponent,
    MateriaPrerrequisitosComponent,
    MateriaMetasCodigosComponent,
    MapaMetasBuscadorComponent,
    MapaMetasResultadoComponent,
    MapaMetasComponent,
    MapaMetaBuscarFormComponent,
    CompartirRubricaClassroomComponent,
    BotonCriterioComponent,
    BotonCriterioGroupComponent,
    RetroalimentacionGridComponent,
    RetroalimentacionCriterioControlComponent,
    RetroalimentacionDialogoComentarioComponent,
    RetroalimentacionTrabajoAlumnoComponent,
    RetroalimentacionGridTablaComponent,
    RetroalimentacionTrabajoCriteriosComponent,
    RetroalimentacionBarraComponent,
    UnidadFormClassroomComponent,
    UnidadFormEnlazarClassroomComponent,
    RetroalimentacionNotificarModalComponent,
    EventoFormClassroomComponent,
    UnidadFormClassroomSelectComponent,
    RetroalimentacionGridClassroomEstadoComponent,
    RetroalimentacionDevolverDialogoComponent,
    UnidadEventoClassroomMcpComponent,
    RetroalimentacionNivelTrabajoCriteriosComponent,
    AutoevaluacionComponent,
    AutoevaluacionNotificacionAlumnoComponent,
    AutoevaluacionCriterioComponent,
    AutoevaluacionCriterioGroupComponent,
    AutoevaluacionCriterioButtonComponent,
    RetroalimentacionReportComponent,
  ],
  imports: [
    CommonModule,
    FormsModule, // TODO: Usar reactive forms en los formularios existentes y remover esta dependencia.
    // HttpClientModule,
    ReactiveFormsModule,
    // CKEditorModule,
    GLMMaterialDesignModule,
    DashboardModule,
    GlmModalModule,
    NavBarModule,
    DynamicBarModule,
    // AngularDraggableModule,
    // SortablejsModule,
    // DragulaModule,
    GlmComentariosModule,
    // GoogleApiModule,
    UserModule,
    CustomPipesModule,
    GLMAppPipesModule.forRoot(),
    GlmD3Module,
    AlumnoCheckboxModule,
    PersonaCardModule,
    CkeditorImageDeleteModule,
    MatMomentDateModule,
    
    ClasePerdidaModule,

    EstudioRoutingModule,
  ],
  providers: [
    {
      provide: MAT_DATE_FORMATS,
      useValue: {
        parse: {
          dateInput: 'L',
        },
        display: {
          dateInput: 'ddd DD MMM YYYY',
          monthYearLabel: 'MMM YYYY',
          dateA11yLabel: 'LL',
          monthYearA11yLabel: 'MMMM YYYY',
        },
      },
    },

  ]
})

export class EstudioModule {
}
